import { render, staticRenderFns } from "./freeitem.vue?vue&type=template&id=59dcb58b&scoped=true&"
import script from "./freeitem.vue?vue&type=script&lang=js&"
export * from "./freeitem.vue?vue&type=script&lang=js&"
import style0 from "./freeitem.vue?vue&type=style&index=0&id=59dcb58b&lang=scss&scoped=true&"
import style1 from "./freeitem.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59dcb58b",
  null
  
)

component.options.__file = "freeitem.vue"
export default component.exports